import { resolveEstimateStatus } from "../../../helpers/estimates";

/** DeskPill tone per estimate status (presentation only). */
export const ESTIMATE_STATUS_TONE = Object.freeze({
  draft: "muted",
  ready: "gold",
  sent: "blue",
  approved: "green",
  declined: "red",
  converted: "green",
  archived: "muted",
});

export function estimateStatusTone(status) {
  return ESTIMATE_STATUS_TONE[resolveEstimateStatus(status)] || "muted";
}

export function formatShortDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
